'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "error", "value", "onBlur"];
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorPercentageInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleRenderedValueChange = ({
      target: {
        value
      }
    }) => {
      const {
        onChange
      } = this.props;
      onChange(SyntheticEvent(value / 100));
    };
  }
  render() {
    const _this$props = this.props,
      {
        className,
        error,
        value,
        onBlur
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isError = error.get('error');
    const errorMessage = error.get('message');
    const renderedValue = value ? value * 100 : value;
    const transferableProps = getTransferableProps(rest);
    const {
      ['data-selenium-test']: dataSeleniumTest,
      placeholder,
      disabled,
      onKeyDown,
      onKeyPress,
      onKeyUp,
      readOnly
    } = transferableProps;
    return /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
        position: "end",
        text: "%",
        children: /*#__PURE__*/_jsx(UINumberInput, {
          className: className,
          "data-selenium-test": dataSeleniumTest,
          disabled: disabled,
          onBlur: onBlur,
          onChange: this.handleRenderedValueChange,
          onKeyDown: onKeyDown,
          onKeyPress: onKeyPress,
          onKeyUp: onKeyUp,
          placeholder: placeholder,
          readOnly: readOnly,
          value: renderedValue
        })
      })
    });
  }
}
FilterOperatorPercentageInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
};